// extracted by mini-css-extract-plugin
export default {"controls":"AlertsControls_controls__tL4RK"};